import { render, staticRenderFns } from "./outwardTransaction.vue?vue&type=template&id=88d79bec&"
import script from "./outwardTransaction.vue?vue&type=script&lang=js&"
export * from "./outwardTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports